import { OurTeamMemberProps } from "@/types/our-team/our-team.types";

/** Stable IDs that map to dict.home.team.designations. */
export type DesignationKey = "software-developer" | "graphics-designer";

export const ourTeamData: (OurTeamMemberProps & { designationKey: DesignationKey })[] = [
  {
    id: 1,
    name: "Shahriar Haque",
    designation: "Software Developer",
    designationKey: "software-developer",
    image: "/assets/team/rahat.avif",
    description: "",
    email: `https://mail.google.com/mail/?view=cm&fs=1&to=shahriar.haque.rahat@gmail.com&su=SUBJECT&body=BODY`,
    linkedin: "https://www.linkedin.com/in/shahriar-haque-rahat/",
    whatsapp: "https://wa.me/+8801600-344133",
    portfolio: "https://shahriar-haque-portfolio.vercel.app/",
  },
  {
    id: 2,
    name: "Ehsanul Kabir Rohan",
    designation: "Graphics Designer",
    designationKey: "graphics-designer",
    image: "/assets/team/ehsanul_kabir_rohan.avif",
    description: "",
    email: `https://mail.google.com/mail/?view=cm&fs=1&to=ehsanulkabirrohan@gmail.com&su=SUBJECT&body=BODY`,
    linkedin: "https://www.linkedin.com/in/ehsanul-kabir-rohan-960a21378/",
    whatsapp: "https://wa.me/+8801705-799443",
    portfolio: "https://ehsanul-kabir-rohan.vercel.app",
  },
  {
    id: 3,
    name: "Kazi Ehsanul Haque",
    designation: "Software Developer",
    designationKey: "software-developer",
    image: "/assets/team/ehsanul_haque_sakib.avif",
    description: "",
    email: `https://mail.google.com/mail/?view=cm&fs=1&to=ehsanulsakib.professional@gmail.com&su=SUBJECT&body=BODY`,
    linkedin: "https://www.linkedin.com/in/kazi-ehsanul-haque/",
    whatsapp: "https://wa.me/+8801865-818118",
    portfolio: "https://kazi-ehsanul-haque.vercel.app/",
  },
  {
    id: 4,
    name: "Kazi Towfiq",
    designation: "Software Developer",
    designationKey: "software-developer",
    image: "/assets/team/ornob.avif",
    description: "",
    email: `https://mail.google.com/mail/?view=cm&fs=1&to=kazitowfiq58@gmail.com&su=SUBJECT&body=BODY`,
    linkedin: "https://www.linkedin.com/in/kazi-towfiq-7b0a08266/",
    whatsapp: "https://wa.me/+8801989-446061",
    portfolio: "https://towfiq-portfolio.vercel.app/",
  },
];
